import React from 'react';
import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { CompassIcon } from '@atlaskit/logo';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { AppLogo } from '@atlaskit/navigation-system';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const styles = cssMap({
	root: {
		maxWidth: '380px',
	},
});

export type AutoCatalogEmptyStateLeftPanelProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onTry: (event: any, analyticsEvent: any) => void;
};

function AutoCatalogEmptyStateLeftPanel(
	props: AutoCatalogEmptyStateLeftPanelProps,
): React.JSX.Element {
	const { formatMessage } = useIntl();
	const { onTry } = props;

	return (
		<>
			<Stack space="space.200" alignInline="start" xcss={styles.root}>
				<AppLogo
					icon={CompassIcon}
					name="Compass"
					label={formatMessage(messages.compass)}
					href="https://www.atlassian.com/software/compass/"
				/>

				<Box paddingBlock="space.200">
					<Heading size="medium" as="h3">
						{formatMessage(messages.title)}
					</Heading>
					<Box padding="space.150" />
					<Text>{formatMessage(messages.description)}</Text>
				</Box>
				<Button appearance="primary" onClick={onTry}>
					{formatMessage(messages.createYourCatalogButton)}
				</Button>
			</Stack>
		</>
	);
}

export default AutoCatalogEmptyStateLeftPanel;
